import appLanding from "./appLanding.json";
import auth from "./auth.json";
import cheapestItemScore from "./cheapestItemScore.json";
import clubImport from "./clubImport.json";
import common from "./common.json";
import company from "./company.json";
import compare from "./compare.json";
import errors from "./errors.json";
import evoBuilder from "./evoBuilder.json";
import evolutions from "./evolutions.json";
import frontPage from "./frontPage.json";
import gallery from "./gallery.json";
import landing from "./landing.json";
import metaRating from "./metaRating.json";
import myClub from "./myClub.json";
import nav from "./nav.json";
import notifications from "./notifications.json";
import objectives from "./objectives.json";
import players from "./players.json";
import profile from "./profile.json";
import sbcSolution from "./sbcSolution.json";
import sbcs from "./sbcs.json";
import squadBuilder from "./squadBuilder.json";
import subscription from "./subscription.json";
import tactics from "./tactics.json";
export default {
    common,
    errors,
    nav,
    auth,
    profile,
    subscription,
    squadBuilder,
    players,
    tactics,
    compare,
    evolutions,
    evoBuilder,
    sbcs,
    sbcSolution,
    myClub,
    notifications,
    clubImport,
    landing,
    frontPage,
    metaRating,
    cheapestItemScore,
    gallery,
    objectives,
    appLanding,
    company,
};
//# sourceMappingURL=index.js.map